import { RAISE_API_V1_URL } from "constants/endpoints";
import { get } from "services/api";

export const getTermsOfUse = async () => {
  const baseUrl = RAISE_API_V1_URL;
  const response = await get(`${baseUrl}/terms-of-use`);
  return response.data;
};
